/* App settings */

import env from "../env.json";
// import CONSTANTS from "./constants.service";

var Settings = env;
console.log(
	"%c%s",
	"color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 10pt",
	"Build No: " + Settings['buildNumber']
);
if (Settings['deployedAt']) {
	console.log(
		"%c%s",
		"color:#e1090a;font-weight:700;padding:5px;text-shadow:0 0 #000;font-size: 10pt",
		"Deployed on: " + Settings['deployedAt']
	);
}

Settings.order = ["VOICE-LCL", "DATA", "VOICE-INT"];

Settings.cc_mask = [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/];
Settings.formats = {
	// email:/^\w(.\w*)+@[a-zA-Z_]+?\.[a-zA-Z]{2,5}$/,
	email: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	cardnumber: /^[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}[ ]{0,1}[0-9]{4}$/,
	cardcvv: /^([0-9]{3})$/,
	cardcvvinitial: /^([0-9]{1,3})$/,
	expiry: /^[0-9]{1,2}\/[0-9]{2}$/,
	phonenumber: /^[0-9]{6,14}$/,
	phonenumberContact: /^[0-9]{6,9}$/,
	phonefragment: /^[0-9]{0,6}$/,
	phonefragmentmax: /^[0-9]{0,6}$/,
	text_only: /^([^0-9]*)$/,
	card_number_mask: [/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/],
	// minLength: /(.{8,})/,
	// oneDigit: /(?=.*?[0-9])/,
	// oneUpperCaseCharacter: /(?=.*[A-Z])/,
	password: /^(?=.*\d)(?=.*[A-Z]).{8,}$/,
	notEmpty: /\S+/,
	otpCode: /^([0-9]{6})$/,
	country: /^([A-Z]{2})$/,
	maxlengthten: 10

};

Settings.Topup = {
	number: {
		value: "",
		validations: {
			requiredObject: true,
			// maxLengthObj: CONSTANTS.TOP_UP_NO_LENGHT,
			// minLength: CONSTANTS.TOP_UP_NO_LENGHT,
			topupNumber:true,
		},
		valid: false,
		touched: false,
		errorMsg: "",
		unique_no: true,
		unique_no_err: "",
	},
	price: {
		value: "",
		validations: {
			requiredObject: true,
			// maxLengthObj: 6,
			maxValue: "",
			minValue: ""
		},
		valid: false,
		touched: false,
		denomination: {},
		discountDetail:{},
		errorMsg: ""
	},
	submit:false
}

Settings.get = function (setting) {
	return Settings[setting];
};

export default Settings;